module.exports = __webpack_public_path__ + "img/pop.288db888.png";